import { PadDesignBase } from './base/pad-design-base';

export class PadDesign extends PadDesignBase { }